import { FlowContext } from 'src/lib/flow';
import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { you } from 'src/lib/flow/text';

export function isEnabled({
  inputContext: { inApp, orePartnerIdentifier },
  featureFlags,
}: FlowContext) {
  return !inApp && !orePartnerIdentifier && !featureFlags.isInHideMarketingAttributionTreatment;
}

const hearAboutOpendoorPage: FlowPage = {
  slug: () => 'hear-about-opendoor',
  title: ({ answers, inputContext: { channel } }) => {
    return `How did ${you(answers, channel)} first hear about Opendoor?`;
  },
  isEnabled,
  autoAdvance: () => true,
  questions: (): FlowQuestion[] => [
    {
      key: 'seller.referral_source',
      type: 'radio_single_select',
      options: [
        {
          label: 'Opendoor "For Sale" sign',
          value: 'for_sale_sign',
        },
        {
          label: 'Word of mouth',
          value: 'word_of_mouth',
        },
        {
          label: 'Radio / Audio',
          value: 'radio',
        },
        {
          label: 'Online ad',
          value: 'online_ad',
        },
        {
          label: 'Homebuilder',
          value: 'homebuilder',
        },
        {
          label: 'TV',
          value: 'tv',
        },
        {
          label: 'Billboard',
          value: 'billboard',
        },
        {
          label: 'Internet search',
          value: 'internet_search',
        },
        {
          label: 'News article',
          value: 'news_article',
        },
        {
          label: 'Postcard / mail',
          value: 'postcard_mail',
        },
        {
          label: 'Marketing survey',
          value: 'marketing_survey',
        },
        {
          label: 'Other',
          value: 'other',
          followUps: [
            {
              key: 'seller.referral_source.other',
              type: 'single_line',
              label: 'Describe how you heard about us',
            },
          ],
        },
      ],
    },
  ],
};

export default hearAboutOpendoorPage;
